import { defineMessage } from 'services/localization';

export const messages = {
    connect: defineMessage('connect'),
    learnMore: defineMessage('learn_more'),
    xeroTitle: defineMessage('approval_workflows_brfor_xero'),
    xeroTooltip: defineMessage('connect_to_your_xero_organisation'),
    xeroDescription: defineMessage('connect_to_your_xero_or_s_invoices_and_contacts'),
    qboTitle: defineMessage('approval_workflows_brfor_quickbooks_online'),
    qboTooltip: defineMessage('connect_to_your_quickbooks_online_organisation'),
    qboDescription: defineMessage('connect_to_your_quickbo_ors_and_journal_entries'),
    netSuiteTitle: defineMessage('approval_workflows_brfor_oracle_netsuite'),
    netSuiteTooltip: defineMessage('connect_to_your_oracle_netsuite_account'),
    netSuiteDescription: defineMessage('connect_to_your_oracle__r_return_authorizations'),
    cin7Title: defineMessage('approval_workflows_brfor_cin_core'),
    cin7Tooltip: defineMessage('connect_to_your_cin_core_account'),
    cin7Description: defineMessage('connect_to_your_cin_cor_lows_for_cin_core_bills'),
};
